





























































import Vue from 'vue';
import Auth from '@aws-amplify/auth';
import amplifyMixin from '@/mixins/amplify';

import ROUTE_NAMES from '@/assets/src/routes';

export default Vue.extend({
  name: 'AuthForgotPassword',

  mixins: [amplifyMixin],

  methods: {
    async changePassword() {
      this.error = '';
      this.message = '';

      Auth.forgotPasswordSubmit(this.username, this.code, this.password)
        .then(() => (this.message = 'You password has been updated. You can now sign in'))
        .catch((error) => this.setError(error));
    },

    async sendCode() {
      this.error = '';
      this.message = '';

      Auth.forgotPassword(this.username)
        .then(() => (this.message = 'A reset password code has been sent to your email'))
        .catch((error) => this.setError(error));
    },
  },

  data() {
    return {
      username: '',
      code: '',
      password: '',
      message:
        'Enter your username and click "Send code". Afterwards, enter the code you have received along with a new password',
    };
  },

  routeNames: ROUTE_NAMES,
});
